module.exports = __webpack_public_path__ + "static/front-f052a94dc4a8d97c583cf3405c0f12d1.png";